// extracted by mini-css-extract-plugin
module.exports = {"heading":"Guessing_heading__2FPIl","gridContainer":"Guessing_gridContainer__3opO_","timer":"Guessing_timer__tBOye"};